<template>
  <div class="h-full w-full hd:w-1/3 fhd:w-1/4 fhd:-ml-40 fhd:self-center">
    <div class="flex flex-col justify-between p-8 font-cursive rounded-full text-center mt-8 sm:-mt-24 4k:-mt-48 w-max shadow-inner dark:text-gray-900 bg-summer-yellow">
      <h1 class="resume-section-title transform rotate-6 dark:text-gray-900">{{ 'hobbies-title' | lang('resume') }}</h1>
      <div v-for="(item, index) in getHobbiesList()" :key="index" class="text-li transform rotate-6">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listHobbies: this.$options.filters.lang('hobbies', 'resume'),
    };
  },
  methods: {
    getHobbiesList() {
      return this.listHobbies;
    },
  },
}
</script>

<style scoped>
.filter-dark {
  filter: invert(44%) sepia(22%) saturate(262%) hue-rotate(182deg) brightness(94%) contrast(86%)
}
</style>